export const EXAM_MAP_0 = "인적성";
export const EXAM_MAP_1 = "적성";
export const EXAM_MAP_2 = "인성";
